
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/connexion",
      function () {
        return require("private-next-pages/auth/connexion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/connexion"])
      });
    }
  